export const PUBLIC_MARKETING_ROUTES = Object.freeze({
  home: '/',
  metadata: '/metadata',
  marketIntelligence: '/market-intelligence',
  vectorizer: '/vectorizer',
  pricing: '/pricing',
  blog: '/blog',
  help: '/help',
  changelog: '/help/changelog',
  freeCredits: '/free-credits',
  feedback: '/feedback',
  about: '/about',
  editorial: '/editorial-policy',
  contact: '/contact',
  privacy: '/privacy',
  terms: '/terms'
});

export const PUBLIC_MARKETING_ANCHORS = Object.freeze({
  platformExports: '#guest-platform-exports',
  coreTools: '#guest-core-tools'
});

export default PUBLIC_MARKETING_ROUTES;
